import { useImperativeHandle } from 'react'
import { IComponentApiProvider, updateActionCard, UpdaterDto } from '@playbooks/action-cards-utils'
import { ActionCard } from '@playbooks/core/src/interfaces/ActionCard'

import { useAppContext } from '../contexts/AppContext'
import { SlidesData } from '../types'

export interface ActionCardsElement {
  getValue: () => ActionCard | null
  getSlides: () => SlidesData
  getSlidesData: () => {
    canProceed: boolean
    slides: SlidesData
  }
  highlightElementIds: (ids: number[]) => void
  partialUpdate: (data: UpdaterDto) => ActionCard
  componentApiProvider: IComponentApiProvider
}

export default function useActionCardsApiRegister(
  ref: React.Ref<ActionCardsElement | null> | undefined,
  slides: SlidesData,
) {
  const {
    data,
    setActionCards,
    prevActionCardsDataRef,
    setHighlightedIds,
    highlightElementsServiceRef,
    componentApiProvider,
  } = useAppContext()

  useImperativeHandle(ref, (): ActionCardsElement => {
    return {
      getValue: () => data ?? null,
      getSlides: () => slides,
      getSlidesData: () => {
        return {
          canProceed: highlightElementsServiceRef.current.getIds().length === 0,
          slides,
        }
      },
      highlightElementIds: (ids: number[]) => {
        const additionalIdsToHighlight = highlightElementsServiceRef.current.getIds()
        setHighlightedIds(Array.from(new Set([...ids, ...additionalIdsToHighlight])))
      },
      partialUpdate: partOfData => {
        const updatedData = JSON.parse(JSON.stringify(updateActionCard(data, partOfData))) as ActionCard

        prevActionCardsDataRef.current = updatedData

        setActionCards(updatedData)

        return updatedData
      },
      get componentApiProvider(): IComponentApiProvider {
        return componentApiProvider
      },
    }
  }, [
    data,
    slides,
    highlightElementsServiceRef,
    setHighlightedIds,
    prevActionCardsDataRef,
    setActionCards,
    componentApiProvider,
  ])
}
